export { default } from './news-section';
